export var QUERY_PARAM_EMAIL = 'email';
export var QUERY_PARAM_INVITE_CODE = 'inviteCode';
export var QUERY_PARAM_INVOICE_ID = 'invoice-id';
export var QUERY_PARAM_PLAN = 'plan';
export var QUERY_PARAM_POSTAL_CODE = 'postalCode';
export var QUERY_PARAM_REDIRECT_TO = 'redirect-to';
export var QUERY_PARAM_REFERRAL_CODE = 'referralCode';
export var QUERY_PARAM_UTM_SOURCE = 'utm_source';
export var QUERY_PARAM_UTM_CAMPAIGN = 'utm_campaign';
export var QUERY_PARAM_UTM_MEDIUM = 'utm_medium';
export var QUERY_PARAM_UTM_TERM = 'utm_term';
export var QUERY_PARAM_UTM_CONTENT = 'utm_content';
export var QUERY_PARAM_TOS_TIMESTAMP = 'timestamp';
export var QUERY_PARAM_PRICE_ID = 'price-id';
export var QUERY_PARAM_LOGIN_ERROR_SOURCE = 'source';
export var QUERY_PARAM_LOGIN_ERROR_CODE = 'error_code';
export var QUERY_PARAM_ONBOARDING_TASK_ID = 'onboarding-task-id';
export var QUERY_PARAM_COMPANY_NAME = 'company-name';
export var QUERY_PARAM_ERROR_TYPE = 'error-type';
export var QUERY_ONBOARDING_TASK_ID = 'onboarding-task-id';
export var QUERY_ERROR = 'error'; // Grin tracking

export var QUERY_PARAM_LINK_ID = 'link_id';
export var QUERY_PARAM_CONTACT_ID = 'contact_id'; // Share-a-sale tracking

export var QUERY_PARAM_SHAREASALE_ID = 'sscid';